import { Grid, Typography, Button, Paper, Box, Link } from "@mui/material";
import { FC, useState } from "react";
import ExostarLogo from "src/assets/exostarLogo.png";
import AuthService from "src/services/auth.service";
import RocheLogoBig from "src/assets/rocheLogoBig.png";
import { useGoogleLogin } from "@react-oauth/google";

const loginBackgroundSx = {
  justifyContent: "center",
  padding: "50px",
  display: "flex",
  flexDirection: "column",
  width: "100vh",
};

const rocheLogoSx = {
  height: 128,
  width: 256,
  placeSelf: "center",
};

const LoginPage: FC = () => {
  const [loading, setLoading] = useState<boolean>(false);

  const googleLogin = useGoogleLogin({
    flow: "auth-code",
    onSuccess: (codeResponse) => {
      setLoading(true);
      console.log("Google codeResp", codeResponse);
      AuthService()
        .getToken(codeResponse.code)
        .then(() => {
          window.location.reload();
        });
    },
    onError: () => {
      console.error("An error occurred");
    },
  });

  return (
    <Grid
      container
      direction="column"
      alignItems="center"
      justifyContent="center"
    >
      <Paper variant="elevation" elevation={2} sx={loginBackgroundSx}>
        <Box
          component="img"
          sx={rocheLogoSx}
          src={RocheLogoBig}
          alt="RocheLogo"
          py={2}
        />
        <Grid item>
          <Typography variant="body2" align="center" gutterBottom>
            I acknowledge that I am bound by confidentiality obligations imposed
            through my employment or contractual agreement with Roche in
            connection with my access to confidential information, including
            Event Verification Automated (EVA) and its contents. By entering
            Event Verification Automated (EVA), I confirm that I understand that
            my activities within Event Verification Automated (EVA) may be
            monitored consistent with local law, and all contents and passwords
            are confidential information, and that unauthorized disclosure or
            use of such confidential information may result in disciplinary
            action including termination of my employment or services and/or
            legal action based on local law.
          </Typography>
        </Grid>
        <Grid item>
          <Typography variant="h5" align="center" gutterBottom>
            Please log in to continue.
          </Typography>
        </Grid>
        <Grid item>
          <Grid container justifyContent="center">
            <Grid item xs={4}>
              <Button
                fullWidth
                variant="outlined"
                color="secondary"
                endIcon={
                  <Box component="img" src={ExostarLogo} alt="ExostarLogo" />
                }
                size="medium"
                onClick={() => AuthService().logIn()}
              >
                Login with
              </Button>
            </Grid>
          </Grid>
        </Grid>
        <Grid item>
          <Box
            // Inner Box: The main content card
            sx={{
              marginTop: 4,
              textAlign: "center",
            }}
          >
            <Typography
              variant="body1"
              component="p"
              sx={{ color: "text.primary" }} // Using MUI theme color for text
            >
              If you are an affiliate,{" "}
              <Link
                component="button" // Renders as a button for semantic correctness when executing an action
                variant="body1"
                onClick={googleLogin} // This invokes the function
                underline="hover" // Adds an underline on hover
                sx={{
                  cursor: "pointer",
                  color: "blue", // Use MUI primary color
                  fontWeight: "medium",
                }}
              >
                click here
              </Link>
            </Typography>
          </Box>
        </Grid>
      </Paper>
    </Grid>
  );
};

export default LoginPage;
